import { createContext, useContext } from "react";
import { useSettingsQuery } from "@/lib/queries";

const SettingsContext = createContext({ settings: null, refresh: () => {} });

const FALLBACK = {
  whatsapp_link: "https://wa.me/447424986641",
  whatsapp_number: "+44(0)7424986641",
  cta_message: "Hi! I'm interested in your premium human hair wigs.",
  brand_name: "Luxury Hair by DEMJ",
  hero_headline: "Premium Human Hair Wigs You Can Trust",
  hero_subheadline:
    "Serving over 700 customers since 2022 with an exceptional 89% repeat customer rate.",
  stat_customers: "700+",
  stat_customers_label: "Customers Served Since 2022",
  stat_repeat: "89%",
  stat_repeat_label: "Repeat Customer Rate",
  stat_premium_label: "Premium Human Hair",
  stat_delivery_label: "Fast Delivery",
  logo_image: "",
};

export function SettingsProvider({ children }) {
  const { data, refetch } = useSettingsQuery();
  const settings = data || FALLBACK;
  return (
    <SettingsContext.Provider value={{ settings, refresh: refetch }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

export function buildWhatsAppLink(settings, extra = "") {
  const base = settings?.whatsapp_link || "https://wa.me/447424986641";
  const msg = encodeURIComponent(
    (extra ? extra + " " : "") +
      (settings?.cta_message || "Hi! I'm interested in your premium human hair wigs.")
  );
  return `${base}?text=${msg}`;
}
